import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/logo_horizontal2.webp'


const _withScopeId = n => (_pushScopeId("data-v-6b252f20"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Amon Sûl",
  height: "80",
  class: "mb-4"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-h4 font-weight-bold" }, "Bienvenido a Amon Sûl", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle-1 mt-2" }, " La plataforma de gestión de eventos del wargame Middle-earth Strategy Battle Game. Organiza eventos, consulta estadísticas de tus partidas, el ranking ELO y sigue la competición en tiempo real. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-h5 font-weight-bold mb-4" }, "Últimas novedades", -1))
const _hoisted_5 = { class: "text-caption font-weight-bold text-primary" }
const _hoisted_6 = { class: "text-h6 novedad-titulo" }
const _hoisted_7 = {
  class: "text-body-2 novedad-texto",
  lang: "es"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-h5 font-weight-bold mb-4" }, "¿Qué puedes hacer?", -1))
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "text-h6 mb-2" }
const _hoisted_11 = { class: "text-body-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "center",
        class: "mt-4 mb-6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        class: "mt-8 mb-2",
        justify: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "10",
            lg: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_timeline, {
                align: "start",
                side: "end",
                density: "compact",
                "truncate-line": "start"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.novedades, (novedad) => {
                    return (_openBlock(), _createBlock(_component_v_timeline_item, {
                      key: novedad.titulo,
                      "dot-color": "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "pa-3",
                          elevation: "2"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(novedad.fecha), 1),
                            _createElementVNode("h3", _hoisted_6, _toDisplayString(novedad.titulo), 1),
                            _createElementVNode("p", _hoisted_7, _toDisplayString(novedad.descripcion), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.features, (feature) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: feature.title,
              cols: "12",
              sm: "6",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: "text-center pa-4",
                  elevation: "3",
                  height: "100%"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: feature.icon,
                      alt: feature.title,
                      width: "72",
                      height: "72",
                      class: "mb-3"
                    }, null, 8, _hoisted_9),
                    _createElementVNode("h3", _hoisted_10, _toDisplayString(feature.title), 1),
                    _createElementVNode("p", _hoisted_11, _toDisplayString(feature.description), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}